// ── Logical canvas / world space (Matter coordinates == canvas coordinates) ──
export const W = 480;
export const H = 720;

export const CONTAINER_W = 400;
export const CONTAINER_H = 560;
export const CONTAINER_LEFT = (W - CONTAINER_W) / 2;   // 40
export const CONTAINER_RIGHT = CONTAINER_LEFT + CONTAINER_W; // 440
export const CONTAINER_TOP = 120;
export const CONTAINER_BOTTOM = CONTAINER_TOP + CONTAINER_H; // 680

export const DEATH_LINE_Y = CONTAINER_TOP + 40;        // 160
export const DROPPER_Y = 80;
export const WALL_THICK = 6;

export const DROP_COOLDOWN_MS = 500;
export const GRACE_MS = 1500;          // fruit must live this long before it can trigger game over
export const WATERMELON_BONUS = 100;

export const MAX_TIER = 11;
export const SPAWN_TIERS = [1, 2, 3];  // tiers eligible for drop

export type GamePhase = 'MENU' | 'PLAYING' | 'PAUSED' | 'GAME_OVER';

export interface FruitDef {
  tier: number;     // 1..11
  name: string;
  radius: number;   // px
  color: string;    // fallback fill
  points: number;   // score awarded when this tier is created by a merge
}

// Per-fruit data stashed on a Matter body (body.plugin)
export interface FruitData {
  tier: number;
  spawnMs: number;
  scaleFrom: number; // spawn-pop start scale (1 = no pop)
}

// ── Transient visual effects (live outside the physics world) ──
export type Effect =
  | { kind: 'flash'; x: number; y: number; r: number; startMs: number; dur: number }
  | { kind: 'gold'; x: number; y: number; r: number; startMs: number; dur: number }
  | { kind: 'puff'; x: number; y: number; blobs: PuffBlob[]; startMs: number; dur: number }
  | { kind: 'particles'; parts: Particle[]; startMs: number; dur: number }
  | { kind: 'popup'; x: number; y: number; text: string; startMs: number; dur: number };

export interface PuffBlob { dx: number; dy: number; r: number; }

export interface Particle {
  x: number; y: number; vx: number; vy: number; color: string; size: number;
}

// Clickable rectangle for canvas-drawn UI buttons
export interface Button {
  x: number; y: number; w: number; h: number;
}
